import React from "react";
import ResetPasswordForm from "../ResetPasswordForm";

const ResetPassword = () => {
  return (
    <div className="min-h-svh w-full flex items-center justify-center bg-muted text-foreground p-6">
      <ResetPasswordForm />
    </div>
  );
};

export default ResetPassword;
